import { render, staticRenderFns } from "./BankCardPreview.vue?vue&type=template&id=1d060003"
import script from "./BankCardPreview.vue?vue&type=script&lang=js"
export * from "./BankCardPreview.vue?vue&type=script&lang=js"
import style0 from "./BankCardPreview.vue?vue&type=style&index=0&id=1d060003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports